import { Filter } from '@nemuru-eng/js-api-client';

import { PendingDataWarning } from '../PendingDataWarning';
import { ApplicationListFactory } from './ApplicationListFactory';
import { ApplicationTypeSelect } from './ApplicationTypeSelect/ApplicationTypeSelect';
import { useApplicationType } from './ApplicationTypeSelect/hooks/useApplicationType';

interface ApplicationListProps {
  merchantId: string;
  channelId?: string;
  agentId?: string;
  filters?: Filter[];
}

export const ApplicationList = ({ merchantId, channelId, agentId, filters }: ApplicationListProps) => {
  const { selectedApplicationType, setSelectedApplicationType, menuItems } = useApplicationType({
    merchantId,
    channelId,
    agentId,
  });

  if (!menuItems.length || !selectedApplicationType) return <PendingDataWarning tId={'THERE_ARE_NO_LISTS_TO_SHOW'} />;

  return (
    <>
      <ApplicationTypeSelect
        selectedType={selectedApplicationType}
        setSelectedType={setSelectedApplicationType}
        menuItems={menuItems}
      />
      <ApplicationListFactory applicationType={selectedApplicationType} filters={filters} />
    </>
  );
};
